import React, { useState } from 'react';
import { Bubble } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { ISelectOptionItemType } from '../type';

const OptionItemInfo = (props: { infoItem: ISelectOptionItemType; }) => {
  const { infoItem } = props || {};
  const [isHover, setIsHover] = useState(false);

  return infoItem?.info ? (
    <div
      className="db-option-info"
      onMouseOver={() => {
        setIsHover(true);
      }}
      onMouseOut={() => {
        setIsHover(false);
      }}
    >
      <Bubble
        trigger="hover"
        arrowPointAtCenter
        placement="top-start"
        content={infoItem?.info}
        dark
      >
        <i>
          <SvgIcon
            className="db-option-info-icon"
            type={isHover ? 'alert-circle-action' : 'alert-circle-m'}
          />
        </i>
      </Bubble>
    </div>
  ) : (
    <></>
  );
};

export default OptionItemInfo;
